import React from "react";
import { Box } from "@material-ui/core";
import ChecksScreen from "../../../components/checksScreen";

const CheckReports = () => {
  return (
    <Box className="order-details-form-container">
      <ChecksScreen />
    </Box>
  );
};

export default CheckReports; 